
import { Component, Vue, Prop } from 'vue-property-decorator';

import formatNumber from '@/shared/filters/format-number';

@Component
export default class ListReceipt extends Vue {
    @Prop({default: {}})
    private listItem: any;

    private eventEmit = {
        eventReloadOrder: 'eventReloadOrder',
        eventCheckALl: 'eventCheckALl'
    };

    private transformNumb(value: number, format: string) {
        if (!(value > 0)) {
            return '0';
        }
        return formatNumber(value, format);
    }

    private async viewDetail(item: any) {
        const routeData = this.$router.resolve({ name: 'receipt-detail', params: { id: item.ID.toString() } });
        window.open(routeData.href, '_blank');
    }
}
